/* @flow */
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { GridList, GridTile } from 'material-ui/GridList';

import type { TutorDocuments_tutor } from './__generated__/TutorDocuments_tutor.graphql';

const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
  gridList: {
    overflowY: 'auto',
  },
};

type Props = {
  tutor: TutorDocuments_tutor,
  handleDocumentClick: any => void,
};

const TutorDocuments = ({ tutor, handleDocumentClick }: Props) => (
  <div style={styles.root}>
    {tutor.documents.length > 0 ? (
      <GridList cellHeight={180} cols={3} style={styles.gridList}>
        {tutor.documents.map(document => (
          <GridTile
            key={document.key}
            title={document.description}
            actionPosition="left"
            titlePosition="top"
            onClick={() => {
              // $FlowFixMe
              handleDocumentClick(document);
            }}
          >
            <img src={document.uri} alt={document.description} />
          </GridTile>
        ))}
      </GridList>
    ) : (
      <div style={{ padding: 10 }}>No Documents Found</div>
    )}
  </div>
);

export default createFragmentContainer(TutorDocuments, {
  tutor: graphql`
    fragment TutorDocuments_tutor on Tutor {
      documents {
        uri
        description
        key
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/approval/TutorDocuments.js